import { useEffect } from 'react';

const useSwipeDetect = (el, callback, isSwipableOnMob = true) => {
  const touchsurface = el;
  let swipedir;
  let startX;
  let startY;
  let distX;
  let distY;
  const threshold = 30; // required min distance traveled to be considered swipe
  const restraint = 100; // maximum distance allowed at the same time in perpendicular direction
  const allowedTime = 1000; // maximum time allowed to travel that distance
  let elapsedTime;
  let startTime;
  const handleswipe = callback;

  const handleTouchStart = (e) => {
    const touchobj = e.changedTouches[0];
    swipedir = 'none';
    distX = 0;
    distY = 0;
    startX = touchobj.pageX;
    startY = touchobj.pageY;
    startTime = new Date().getTime(); // record time when finger first makes contact with surface
  };

  const handleTouchMove = (e) => {
    e.preventDefault();
  };

  const handleTouchEnd = (e) => {
    const touchobj = e.changedTouches[0];
    distX = touchobj.pageX - startX; // get horizontal dist traveled by finger while in contact with surface
    distY = touchobj.pageY - startY; // get vertical dist traveled by finger while in contact with surface
    elapsedTime = new Date().getTime() - startTime; // get time elapsed
    if (elapsedTime <= allowedTime) {
      // first condition for awipe met
      if (Math.abs(distX) >= threshold && Math.abs(distY) <= restraint) {
        // 2nd condition for horizontal swipe met
        swipedir = distX < 0 ? 'left' : 'right'; // if dist traveled is negative, it indicates left swipe
      } else if (Math.abs(distY) >= threshold && Math.abs(distX) <= restraint) {
        // 2nd condition for vertical swipe met
        swipedir = distY < 0 ? 'up' : 'down'; // if dist traveled is negative, it indicates up swipe
      }
    }
    handleswipe(swipedir);
  };
  useEffect(() => {
    if (touchsurface && isSwipableOnMob && handleswipe) {
      touchsurface.addEventListener('touchstart', handleTouchStart, false);

      touchsurface.addEventListener('touchmove', handleTouchMove, false);

      touchsurface.addEventListener('touchend', handleTouchEnd, false);
    }

    return () => {
      if (touchsurface && isSwipableOnMob && handleswipe) {
        touchsurface.removeEventListener('touchstart', handleTouchStart, false);

        touchsurface.removeEventListener('touchmove', handleTouchMove, false);

        touchsurface.removeEventListener('touchend', handleTouchEnd, false);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [touchsurface, handleswipe]);
};

export default useSwipeDetect;
